import Vue from 'vue';
export const EventBus = new Vue({
	data: {
		//apiPath: 'http://localhost',
		//sitePath: 'http://localhost:8080',
		apiPath: 'https://api.myxplora.com',
		//sitePath: 'https://promo.myxplora.co.uk',
		sitePath: 'https://myxplora.co.uk',
	}
});


// WEBPACK FOOTER //
// ./src/components/EventBus.js